<div class="filters">
  <div>
    <mat-form-field>
      <mat-icon matPrefix color="primary">search</mat-icon>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
      <mat-hint *ngIf="data.name && data.name.length<3" align="end">3 caractères minimum</mat-hint>
    </mat-form-field>

    <button *ngIf="showPropertyFilter" mat-mini-fab color="primary" class="white" appTooltip="Filtrer la liste"
      [matMenuTriggerFor]="menuAttrGrp">
      <mat-icon>filter_list</mat-icon>
    </button>
  </div>
  <mat-menu #menuAttrGrp="matMenu">
    <ng-template matMenuContent>
      <button mat-menu-item [matMenuTriggerFor]="menuType">Types de biens</button>
      <button *ngFor="let group of filterDisplayAttributeGroups" mat-menu-item [matMenuTriggerFor]="menuAttr"
        [matMenuTriggerData]="{group: group.code}">{{group.display.name}}</button>
    </ng-template>
  </mat-menu>

  <mat-menu #menuType="matMenu">
    <ng-template matMenuContent>
      <div class="m-2" *ngFor="let type of globalAvailablePropTypes">
        <mat-checkbox (change)="filterPropertyType(type,$event.checked)" [value]="type"
          [checked]="data.types.indexOf(type)>-1">{{ propHelper.getTypeName(type) }}</mat-checkbox>
      </div>
    </ng-template>
  </mat-menu>

  <mat-menu #menuAttr="matMenu">
    <ng-template matMenuContent let-group="group">
      <button *ngFor="let attr of this.filterDisplayAttributes[group]" [matMenuTriggerFor]="menuAttrValues"
        [matMenuTriggerData]="{attr: attr}" [disabled]="filterAttributesValue[attr.code]"
        mat-menu-item>{{attr.display.name}}</button>
    </ng-template>
  </mat-menu>

  <mat-menu #menuAttrValues="matMenu">
    <ng-template matMenuContent let-attr="attr">
      <button *ngIf="!filterDisplayAttributeValues[attr.code]; else displayValues"
        (click)="addFilterAttributeValueDialog(attr)" mat-menu-item>Entrer une valeur</button>
      <ng-template #displayValues>
        <button *ngFor="let attrValue of filterDisplayAttributeValues[attr.code]"
          (click)="addFilterAttributeValue(attr,attrValue.value)" mat-menu-item>{{attrValue.name}}</button>
      </ng-template>
    </ng-template>
  </mat-menu>

  <mat-chip-listbox #attrList aria-label="Attributs filtrés">
    <mat-chip-option *ngFor="let type of data.types" (removed)="resetTypeValueFilter(type)">
      Type : {{ propHelper.getTypeName(type)}}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-option>
    <mat-chip-option *ngFor="let attrCode of filterAttributesCode" (removed)="resetAttributeValueFilter(attrCode)">
      {{dictCacheService.getAttrDisplayNameFromCode(attrCode)}} : {{filterAttributesValue[attrCode].name}}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-option>
  </mat-chip-listbox>

  <mat-slide-toggle *ngIf="showMoreDetail" (change)="toggleDisplayColumns()" [checked]="displayFullColumns">Plus de
    détails</mat-slide-toggle>
  <mat-slide-toggle *ngIf="showChildrenBtn" (change)="toggleDisplayChildren()" [checked]="displayChildren">Voir tous les
    lots</mat-slide-toggle>

</div>